<div id="dark" style="margin-top: 2%; ">

  <ngx-marquee pauseOnHover="true" duration="600s">
    <div *ngFor="let company of companies" style="display: inline-block;">
      <div style="background-color: #1c1c1c; font-size: small;" class="card" *ngIf="company.ENG_NAME != null">
        <div class="p-1">
          <div class="d-flex" style="cursor: default;">
            <div class="mr-auto p-1 font-weight-bold" style="text-overflow:ellipsis !important;color:rgb(190, 190, 190);font-size: 13px;white-space: nowrap;overflow: hidden;">
              {{company.Reuters}}
            </div>
            <div class="p-1" [ngClass]="company.LAST_CHANGE_PRC>0?'green' : 'red'">
              {{company.LAST_CHANGE_PRC | number : '1.2-2'}}%
              <i class="ion-md-trending-up" *ngIf="company.LAST_CHANGE_PRC>0"></i>
              <i class="ion-md-trending-down" *ngIf="company.LAST_CHANGE_PRC<0"></i>
            </div>
          </div>
          <div class="d-flex" style="max-width: 100%;">
            <div class="mr-auto p-1" style="text-overflow:ellipsis !important;color:rgb(238, 238, 238);white-space: nowrap;overflow: hidden;">
              {{company.ENG_NAME}}
            </div>
            <div class="p-1" style="color:rgb(238, 238, 238)">
              {{company.LAST_TRADE_PRICE | currency:"EGP":"symbol"}}
            </div>
          </div>
        </div>
      </div>
    </div>
  </ngx-marquee>


  <!--
  <marquee width="100%" height="auto" onmouseover="this.stop();" onmouseout="this.start();" scrollamount="10">

  </marquee> -->

  <ktd-grid [cols]="cols" [rowHeight]="rowHeight" [layout]="layout" (layoutUpdated)="onLayoutUpdated($event)">


    <ktd-grid-item *ngFor="let item of layout; trackBy:trackById" [id]="item.id">
      <div class="d-flex" class="item-buttons close-widget">
        <button *ngIf="item.dragEnabled" mat-icon-button class="resize-handle-1" style="cursor: grab;">
          <mat-icon style="font-size: 18px;" ktdGridResizeHandle>open_with</mat-icon>
        </button>
        <button mat-icon-button *ngIf="item.id != 'market-watch'">
          <mat-icon style="font-size: 18px;" (click)="removeItem(item.id)">close</mat-icon>
        </button>
      </div>
      <ndc-dynamic #MWT [ndcDynamicComponent]="get(item.id)" [ndcDynamicInputs]="{symbolCode:(item.symbolCode == null)?
        selectedCompanySymbol:item.symbolCode, reuters:(item.reuters == null)?
        null:item.reuters, companyName:(item.companyName == null)?
        null:item.companyName}">
      </ndc-dynamic>
    </ktd-grid-item>
  </ktd-grid>

</div>
